export default {
	common: {
		appTitle: 'Soft AI',
		loading: 'Ładowanie…',
		loadMore: 'Załaduj więcej',
	},

	language: {
		title: 'Język',
		subtitle: 'Wybierz preferowany język',
		description:
			'Interfejs, menu i opisy postaci będą wyświetlane w wybranym języku. Możesz zmienić go w dowolnym momencie.',
		selectLanguage: 'Wybierz język',
		active: 'Aktywny',
		pl: 'Polski',
		plDescription: 'Interfejs i treści po polsku',
		de: 'Deutsch',
		deDescription: 'Interfejs i treści po niemiecku',
		en: 'English',
		enDescription: 'Interfejs i treści po angielsku',
		cs: 'Čeština',
		csDescription: 'Interfejs i treści po czesku',
		close: 'Zamknij',
	},

	login: {
		title: 'Soft AI',
		subtitle: 'Znajdź idealnego towarzysza.',
		subtitleLogin: 'Wprowadź hasło, aby kontynuować.',
		subtitleSetPassword:
			'To konto już istnieje. Ustaw hasło, aby się zalogować.',
		subtitleRegister: 'Utwórz konto, aby rozpocząć.',
		emailLabel: 'Adres e-mail',
		emailPlaceholder: 'Wprowadź swój e-mail',
		passwordLabel: 'Hasło',
		passwordPlaceholder: '••••••••',
		passwordSetPlaceholder: 'utwórz hasło',
		passwordLabelRegister: 'Ustaw hasło',
		confirmPasswordLabel: 'Potwierdź hasło',
		confirmPasswordPlaceholder: 'Potwierdź swoje hasło',
		loginButton: 'Zaloguj się',
		loggingIn: 'Logowanie...',
		checkingEmail: 'Sprawdzanie adresu e-mail...',
		registering: 'Tworzenie konta...',
		loginSuccessButton: 'Zalogowano',
		registerSuccessButton: 'Konto utworzone',
		continueButton: 'Kontynuuj',
		registerButton: 'Zarejestruj',
		setPasswordButton: 'Ustaw hasło',
		forgotPasswordLink: 'Zapomniałeś hasła?',
		registerLink: 'Zarejestruj się',
		goBackLink: 'Zmień e-mail',
		resetPasswordLink: 'Zresetuj hasło',
		resetModalTitle: 'Zresetuj hasło',
		resetModalHint:
			'Podaj swój e-mail, a wyślemy Ci link do zresetowania hasła.',
		sendResetLinkButton: 'Wyślij link resetujący',
		resetSending: 'Wysyłanie...',
		resetBackToLogin: 'Wróć do logowania',
		resetSuccessTitle: 'Sprawdź skrzynkę',
		resetSuccessHint: 'Wysłaliśmy link do zresetowania hasła.',
		resetSuccessMessage:
			'Jeśli konto z tym adresem istnieje, link resetujący pojawi się wkrótce w Twojej skrzynce. Sprawdź też folder spam.',
		passwordMismatch: 'Hasła nie są identyczne.',
		passwordRequirements: 'Co najmniej 6 znaków.',
		passwordTooShort: 'Hasło musi mieć co najmniej 6 znaków.',
		passwordNeedsNumber: 'Hasło musi zawierać co najmniej jedną cyfrę.',
		passwordNeedsSpecial:
			'Hasło musi zawierać co najmniej jeden znak specjalny.',
		errorMessage: 'Nieprawidłowy adres e-mail lub hasło. Spróbuj ponownie.',
		wrongPasswordMessage: 'Nieprawidłowe hasło. Spróbuj ponownie.',
		accountExistsLogin: 'To konto już istnieje. Zaloguj się.',
		showPassword: 'Pokaż hasło',
		hidePassword: 'Ukryj hasło',
	},

	restartPassword: {
		statusLoading: 'Sprawdzanie',
		statusReady: 'Reset',
		statusSuccess: 'Gotowe',
		statusInvalid: 'Wygasły',
		loadingTitle: 'Sprawdzamy link',
		loadingMessage: 'Chwilę poczekaj — weryfikujemy link do resetu hasła.',
		invalidTitle: 'Ten link jest nieważny',
		invalidMessage:
			'Link wygasł lub został już użyty. Poproś o nowy z ekranu logowania.',
		successTitle: 'Hasło zaktualizowane',
		successMessage: 'Nowe hasło jest gotowe. Możesz się zalogować do Soft AI.',
		formTitle: 'Ustaw nowe hasło',
		formMessage: 'Wybierz nowe hasło do konta. Link jest ważny 24 godziny.',
		passwordLabel: 'Nowe hasło',
		passwordPlaceholder: 'Wpisz nowe hasło',
		confirmPasswordLabel: 'Potwierdź hasło',
		confirmPasswordPlaceholder: 'Powtórz nowe hasło',
		passwordRequirements: 'Co najmniej 6 znaków.',
		passwordResetTooShort: 'Hasło musi mieć co najmniej 6 znaków.',
		passwordMismatch: 'Hasła nie są identyczne.',
		submitButton: 'Zapisz nowe hasło',
		submitting: 'Zapisywanie...',
		backToApp: 'Wróć do Soft AI',
		showPassword: 'Pokaż hasło',
		hidePassword: 'Ukryj hasło',
		errorGeneric: 'Nie udało się zmienić hasła. Spróbuj ponownie lub poproś o nowy link.',
	},

	studio: {
		createTitlePrefix: 'Stwórz swoją',
		createTitleHighlight: 'Softie',
		navigation: 'Nawigacja Studio',
		back: 'Wstecz',
		next: 'Dalej',
		createSoftie: 'Utwórz Softie',
		chooseGender: 'Wybierz płeć',
		chooseEthnicity: 'Wybierz pochodzenie etniczne',
		chooseHairstyle: 'Wybierz fryzurę',
		chooseHairColor: 'Wybierz kolor włosów',
		chooseBodyType: 'Wybierz typ sylwetki',
		chooseEyeColor: 'Wybierz kolor oczu',
		chooseBreastSize: 'Wybierz rozmiar biustu',
		chooseBulgeSize: 'Wybierz rozmiar',
		chooseAge: 'Wybierz wiek',
		confirmAge: 'Potwierdź',
		ageLabel: 'Wiek',
		yearsOld: 'lat',
		finalTitle: 'Spraw, by Twój Softie był naprawdę Twój',
		generatingTitle: 'Generowanie postaci',
		creatingSoftie: 'Tworzymy twoją Softie',
		generatingHint: 'Łączymy wygląd, klimat i głos w jedną osobowość.',
		generatingPhaseLook: 'Kształtujemy wygląd',
		generatingPhasePersona: 'Tkamy osobowość',
		generatingPhaseAwaken: 'Budzimy do życia',
		generatingPhoto: 'Generowanie zdjęcia...',
		estimatedPhotoTimeRemaining: 'Szacowany czas: {seconds}s',
		estimatedVideoTimeRemaining: 'Prawie gotowe: {seconds}s',
		resultTitle: 'Twój Softie czeka',
		awakenSoftie: 'Obudź Softie',
		meetMySoftie: 'Poznaj swoją Softie',
		rerollLook: 'Losuj wygląd ponownie',
		name: 'Imię',
		fieldEthnicity: 'Pochodzenie',
		fieldAge: 'Wiek',
		fieldEyeColor: 'Kolor oczu',
		fieldBodyType: 'Typ sylwetki',
		fieldHairstyle: 'Fryzura',
		fieldHairColor: 'Kolor włosów',
		fieldBreastSize: 'Rozmiar biustu',
		fieldBulgeSize: 'Rozmiar',
		personality: 'Osobowość',
		occupation: 'Zawód',
		relationship: 'Relacja',
		nationality: 'Narodowość',
		city: 'Miasto',
		zodiac: 'Znak zodiaku',
		kinks: 'Preferencje',
		voice: 'Głos',
		confirmFinal: 'Potwierdź',
		namePlaceholder: 'Imię postaci',
		cityPlaceholder: 'Miasto',
		done: 'Gotowe',
		gridOptionLabels: {},
		gender: {
			chooseGender: 'Wybierz płeć',
			woman: 'Kobieta',
			men: 'Mężczyzna',
			trans: 'Trans',
		},
	},

	imageGeneration: {
		title: 'Generator postaci AI',
		subtitle:
			'Ożyw swoją fantazję: wybierz każdy szczegół, od spojrzenia po strój.',
		characterName: 'Imię postaci',
		characterNamePlaceholder: 'np. Aleksandra, Zoja, Carmen...',
		prompt: 'Prompt',
		promptPlaceholder:
			'np. Blondynka w czerwonej sukience na tle nocnego miasta...',
		randomPrompt: 'Nie wiesz, co napisać? Kliknij, aby wygenerować opis!',
		customization: 'Personalizacja postaci',
		numberOfImages: 'Liczba obrazów do wygenerowania',
		imageCount: '{count} obraz',
		imagesCount: '{count} obrazy',
		generating: 'Generowanie...',
		generateCharacter: 'Generuj postać',
		historyTitle: 'Historia wygenerowanych postaci',
		loading: 'Ładowanie...',
		emojiIconAlt: 'Ikona emoji',
	},

	nav: {
		mainNavigation: 'Główna nawigacja',
		lounge: 'Lounge',
		discover: 'Odkrywaj',
		chat: 'Czat',
		studio: 'Studio',
		mySofties: 'Moje Softies',
	},

	topBar: {
		sparkBalance: 'Saldo Spark',
		openSparkPackages: 'Otwórz pakiety Spark',
		totalBalance: 'Całkowite saldo',
		account: 'Konto',
		logIn: 'Zaloguj się',
		register: 'Zarejestruj się',
	},

	authModal: {
		loginTitle: 'Zaloguj się, aby kontynuować',
		registerTitle: 'Utwórz konto',
		loginHint:
			'Witaj ponownie. Zaloguj się, aby rozpocząć czat ze swoimi Softies.',
		registerHint:
			'Załóż darmowe konto, aby odblokować czat i zapisać swoje postacie.',
		visualTitle: 'Poznaj swoje Softies',
		visualDescription:
			'Twórz postacie, odkrywaj style i odblokuj czat za darmo.',
		loginVisualTitle: 'Witaj ponownie',
		loginVisualDescription: 'Zaloguj się i wróć do swoich Softies.',
		guestBrowseHint:
			'Przeglądaj postacie za darmo. Zaloguj się lub zarejestruj, aby czatować, tworzyć Softies i odblokować pełny dostęp.',
		hasAccountPrompt: 'Masz już konto?',
		switchToLogin: 'Zaloguj się',
		noAccountPrompt: 'Nie masz jeszcze konta?',
		switchToRegister: 'Zarejestruj się',
		loginAction: 'Zaloguj się',
		registerAction: 'Zarejestruj się',
		continueBrowsing: 'Kontynuuj przeglądanie',
		tabSwitcherLabel: 'Tryb logowania',
		close: 'Zamknij',
	},

	sparkModal: {
		premiumAccess: 'Dostęp Premium',
		premiumDescription:
			'Doładuj Sparki, aby generować obrazy, filmy i unikalne chwile bez czekania.',
		closeSparkPackages: 'Zamknij pakiety Spark',
		selectPackage: 'Wybierz pakiet',
		usageTitle: 'Jak wykorzystywane są Sparki:',
		messageUsage: 'Wiadomość:',
		messageUsageValue: '0 Sparków',
		voiceUsage: 'Głos:',
		voiceUsageValue: '0 Sparków',
		photoUsage: 'Zdjęcie:',
		photoUsageValue: '5 Sparków',
		videoUsage: 'Wideo:',
		videoUsageValue: '50 Sparków',
		characterUsage: 'Tworzenie postaci:',
		characterUsageValue: '100 Sparków',
		sparkPackages: 'Pakiety Spark',
		termsOfService: 'Regulamin',
		privacyPolicy: 'Polityka prywatności',
		acceptTermsPrefix: 'Akceptuję',
		acceptTermsAnd: 'oraz',
		selectPackageButton: 'Wybierz pakiet',
		continueWithPrice: 'Kontynuuj ({price})',
		packages: {
			basic: {
				name: 'BASIC',
				sparks: '1000 Sparków',
			},
			pro: {
				name: 'PRO',
				sparks: '3000 Sparków',
			},
			premium: {
				name: 'PREMIUM',
				sparks: '6000 Sparków',
			},
		},
	},

	profileAccount: {
		account: 'Konto',
		displayName: 'Nazwa wyświetlana',
		nameRequired: 'Nazwa wyświetlana jest wymagana.',
		nameSaveError: 'Nie udało się zapisać nazwy. Spróbuj ponownie.',
		tokens: 'Tokeny',
		planValidUntil: 'Plan ważny do',
		memberSince: 'Członek od:',
		support: 'Wsparcie: support@softai.today',
		supportLabel: 'Wsparcie',
		supportEmail: 'support@softai.today',
		logOut: 'Wyloguj się',
		loggingOut: 'Wylogowywanie...',
		privacyPolicy: 'Polityka prywatności',
		termsOfUse: 'Warunki użytkowania',
	},

	home: {
		stories: 'Historie',
		previousStories: 'Poprzednie historie',
		nextStories: 'Następne historie',
		storyClose: 'Zamknij historię',
		storyPrev: 'Poprzednia historia',
		storyNext: 'Następna historia',
		storyPlay: 'Odtwórz',
		storyPause: 'Wstrzymaj',
		storyTimeAgo: '5h',
		storyReplyPlaceholder: 'Napisz wiadomość...',
		storyReplySend: 'Wyślij',
		loungeHighlight: 'Wyróżnienie Lounge',
		loungeTitlePrefix: 'Wybierz swoją',
		loungeTitleSoftie: 'Softie',
		loungeTitleMiddle: ', podążaj za',
		loungeTitleVibe: 'klimatem',
		surpriseMe: 'Zaskocz mnie',
		loungeCategories: 'Kategorie Lounge',
		previousCategories: 'Poprzednie kategorie',
		nextCategories: 'Następne kategorie',
		categoriesLabel: 'Kategorie',
		all: 'Wszystkie',
		loadingTags: 'Ładowanie tagów…',
		categories: {
			Neighbor: 'Sąsiadka',
			Romantic: 'Romantyczna',
			Sweet: 'Słodka',
			Naughty: 'Psotna',
			Mature: 'Dojrzała',
			Luxury: 'Luksusowa',
			Fitness: 'Sportowa',
			Bossy: 'Dominująca',
			Nerdy: 'Nerdy',
			Trans: 'Trans',
			Mystic: 'Mistyczna',
			Fantasy: 'Fantasy',
			Men: 'Mężczyźni',
		},
	},

	discover: {
		ariaLabel: 'Odkrywaj postacie',
		back: 'Wróć do Lounge',
		swipeHint: 'Przesuń w górę po więcej',
		loadingProfiles: 'Ładowanie postaci...',
	},

	mySofties: {
		titlePrefix: 'Moje',
		titleHighlight: 'Softies',
		createSoftie: 'Stwórz swoją Softie',
	},

	profileModal: {
		close: 'Zamknij profil',
		characterGallery: 'Galeria postaci',
		previousPhoto: 'Poprzednie zdjęcie',
		nextPhoto: 'Następne zdjęcie',
		photoNumber: 'Zdjęcie {number}',
		startChatting: 'Zacznij',
		meta: '{age} lat · {origin}',
		defaultOrigin: 'Nieznany',
		personalityAttributes: 'Cechy osobowości',
		physicalAttributes: 'Cechy fizyczne',
		occupation: 'Zawód',
		relationship: 'Relacja',
		kinks: 'Preferencje',
		ethnicity: 'Pochodzenie etniczne',
		country: 'Kraj',
		age: 'Wiek',
		bodyType: 'Typ sylwetki',
		zodiacSign: 'Znak zodiaku',
		unknown: 'Nieznany',
		defaultOccupation: 'Towarzysz',
		defaultRelationship: 'Singiel',
		defaultZodiac: 'Waga',
		defaultKinks: 'Drażnienie',
	},

	profileCard: {
		portraitAlt: 'Portret {name}',
		regenerateImage: 'Wygeneruj obraz ponownie',
		ageShort: 'lat',
	},

	chat: {
		conversationPanel: 'Panel rozmowy',
		companionProfile: 'Profil towarzysza',
		loadingTitle: 'Ładowanie rozmowy...',
		loadingText:
			'Pobieranie danych użytkownika i czatu. Proszę chwilę poczekać.',
		noConversationTitle: 'Nie wybrano rozmowy',
		noConversationText:
			'Wybierz istniejącą rozmowę z listy lub rozpocznij nową, aby zacząć czatować.',
		online: 'Online',
		back: 'Wstecz',
		generatingImage: 'Generowanie obrazu...',
		generatingVideo: 'Przygotowywanie wideo...',
		estimatedTimeRemaining: 'Szacowany czas: {seconds}s',
		estimatedTextTimeRemaining: 'Szacowany czas: {seconds}s',
		estimatedVideoTimeRemaining: 'Prawie gotowe: {seconds}s',
		writeMessage: 'Napisz wiadomość...',
		sendMessage: 'Wyślij wiadomość',
		sendMePhoto: 'Wyślij mi zdjęcie',
		sendMeVideo: 'Wyślij mi wideo',
		call: 'Zadzwoń',
		endCall: 'Zakończ połączenie',
		callInProgress: 'Trwa połączenie',
		voiceCallActive: 'Połączenie głosowe aktywne',
		voiceCallStartSpeaking: 'Zacznij mówić...',
		voiceCallSpeaking: 'Ona mówi...',
		voiceCallYouSpeaking: 'Mówisz...',
		voiceCallProcessing: 'Łączenie odpowiedzi...',
		callMessage: 'Hej, jesteś tam?',
		videoReply: 'Jasne, oto Twoje wideo.',
		videoNotAvailable: 'Wideo nie jest jeszcze dostępne dla tego towarzysza.',
		fetchMessagesError:
			'Coś poszło nie tak podczas ładowania wiadomości. Spróbuj ponownie.',
		illegalContentError:
			'Twoja wiadomość nie jest dozwolona. Nie możemy wygenerować takiej treści.',
		noTokensError: 'Brak Sparków! Doładuj, aby kontynuować tworzenie.',
		imageGenerationError:
			'Nie udało się wygenerować zdjęcia. Spróbuj ponownie za chwilę.',
		videoGenerationError:
			'Nie udało się wygenerować wideo. Spróbuj ponownie za chwilę.',
		guestGateTitle: 'Zarejestruj się, aby rozpocząć czat',
		guestGateDescription:
			'Stwórz konto, wybierz plan i zacznij rozmawiać ze swoją Softie w kilka chwil.',
		guestGateHeroTitle: 'Twój Softie czeka',
		guestGateHeroDescription:
			'Zarejestruj się, aby odblokować czat, zdjęcia i spersonalizowane chwile.',
		guestGateRegister: 'Zarejestruj się',
		guestGateLogin: 'Mam już konto',
		planPaywallTitle: 'Wybierz swój plan',
		planPaywallDescription: 'Pełny dostęp do czatu i tworzenia treści.',
		planPaywallBenefitUncensored: 'Rozmowy bez cenzury i ograniczeń',
		planPaywallBenefitPrivatePhotos: 'Ekskluzywne prywatne zdjęcia',
		planPaywallBenefitPriorityAi: 'Priorytetowe przetwarzanie AI',
		planPaywallHeroTitle: 'Premium dostęp',
		planDurationBasic: '1 miesiąc pełnego dostępu',
		planDurationPro: '3 miesiące pełnego dostępu',
		planDurationPremium: '6 miesięcy pełnego dostępu',
		planPaywallSelectPlan: 'Wybierz plan',
		planPaywallContinue: 'Kontynuuj ({price})',
		planPaywallPopular: 'Popularny',
		planCheckoutSectionEyebrow: 'Kasa',
		planCheckoutSectionTitle: 'Szczegóły płatności',
		planCheckoutSectionSubtitle: 'Wybierz metodę i sfinalizuj zakup',
		planCheckoutSelectedPlan: 'Wybrany plan',
		planCheckoutClose: 'Zamknij wybór planu',
		planCheckoutCompleteTitle: 'Dokończ płatność',
		planCheckoutOneOffSubtitle: 'Bezpieczna płatność przez Stripe.',
		planCheckoutSubscriptionSubtitle:
			'Bezpieczna subskrypcja miesięczna przez Stripe. Podaj dane karty poniżej.',
		planCheckoutRecurring: 'Płatność cykliczna • Anuluj w dowolnym momencie',
		planCheckoutProcessing: 'Przetwarzanie...',
		planCheckoutCreatingSubscription: 'Tworzę subskrypcję...',
		orderStatusVerifyingPayment: 'Weryfikuję płatność...',
		orderStatusPillVerifying: 'Weryfikacja',
		orderStatusPillSuccess: 'Sukces',
		orderStatusPillFailed: 'Błąd',
		orderStatusRedirecting: 'Przekierowanie za chwilę...',
		orderStatusVerifyingPaymentDescription:
			'Potwierdzamy Twoją płatność. To może potrwać do 2 minut.',
		orderStatusPaymentSuccess: 'Plan opłacony!',
		orderStatusPaymentSuccessDescription:
			'Twoja subskrypcja jest aktywna. Za chwilę przekierujemy Cię dalej.',
		orderStatusTokensSuccess: 'Sparki doładowane!',
		orderStatusTokensSuccessDescription:
			'Płatność potwierdzona. Za chwilę wrócisz do czatu.',
		orderStatusPaymentFailed: 'Płatność nie powiodła się',
		orderStatusPaymentFailedDescription:
			'Nie udało się potwierdzić płatności. Spróbuj ponownie lub skontaktuj się z obsługą.',
		orderStatusPaymentTimeout:
			'Nie udało się potwierdzić płatności w czasie 2 minut. Spróbuj ponownie.',
		orderStatusBackToCheckout: 'Wróć do płatności',
		orderStatusGoToLogin: 'Przejdź do logowania',
		planCheckoutSubscribe: 'Subskrybuj ({price})',
		planCheckoutPaymentLabel: 'Metoda płatności',
		planCheckoutCardLabel: 'Dane karty',
		planCheckoutSubscribeTermsPrefix: 'Subskrybując, akceptujesz',
		planCheckoutPay: 'Zapłać {price}',
		planCheckoutTermsPrefix: 'Dokonując zakupu, akceptujesz',
		planCheckoutTermsLink: 'Regulamin',
		planCheckoutTermsAnd: 'oraz',
		planCheckoutPrivacyLink: 'Politykę prywatności',
		planCheckoutSecureStripe: 'Stripe · szyfrowane · bezpieczne',
		planCheckoutBadge: 'Premium',
		planCheckoutLoadingPayment: 'Ładowanie formularza płatności...',
		planCheckoutPaymentError:
			'Nie udało się uruchomić płatności. Spróbuj ponownie.',
		planCheckoutStripeMissing: 'Brak klucza Stripe (VITE_STRIPE_PUBLIC_KEY).',
		planCheckoutLoginRequired: 'Zaloguj się, aby opłacić plan.',
		tokensExhaustedTitle: 'Skończyły Ci się Sparki',
		tokensExhaustedDescription:
			'Doładuj Sparki, aby kontynuować rozmowę i generować nowe treści.',
		tokensExhaustedHeroTitle: 'Doładuj Sparki',
		tokensExhaustedHeroDescription:
			'Wybierz pakiet Sparków i wróć do czatu bez przerwy.',
		generatedImageAlt: 'Wygenerowany obraz',
		generatedVideoAlt: 'Wygenerowane wideo',
		videoLoadError:
			'Nie udało się załadować wideo. Odśwież stronę i spróbuj ponownie.',
		feedbackActionsLabel: 'Opinia',
		feedbackLikeTitle: 'Co Ci się podobało w tej odpowiedzi?',
		feedbackDislikeTitle: 'Co powinniśmy poprawić?',
		feedbackDislikePlaceholder: 'Wymagane: Opisz problem (min. 5 znaków)',
		feedbackOptionalPlaceholder: 'Twoja opinia (opcjonalnie)',
		feedbackSkip: 'Pomiń',
		feedbackSubmit: 'Wyślij',
		feedbackSending: 'Wysyłanie...',
		feedbackMinLengthHint:
			'Napisz wiadomość (min. 5 znaków) lub naciśnij „Pomiń", aby wysłać opinię bez tekstu.',
		feedbackHint:
			'Możesz zostawić krótką wiadomość lub pominąć i zamknąć okno.',
		feedbackSkippedText: 'Brak tekstu (pominięto)',
		messageActionsLabel: 'Akcje wiadomości',
		tooltipLike: 'Lubię to',
		tooltipDislike: 'Do poprawy',
		tooltipListen: 'Odsłuchaj',
		listenToMessage: 'Odsłuchaj wiadomość',
		speakLoading: 'Ładowanie głosu...',
		speakStop: 'Zatrzymaj odtwarzanie',
		speakError: 'Coś poszło nie tak podczas odtwarzania głosu. Spróbuj ponownie.',
		galleryClose: 'Zamknij',
		galleryPrev: 'Poprzednie',
		galleryNext: 'Następne',
		galleryError: 'Błąd ładowania obrazu',
		hide: 'Ukryj',
		showChatList: 'Pokaż listę czatów',
		hideChatList: 'Ukryj listę czatów',
		showProfilePanel: 'Pokaż panel profilu',
		hideProfilePanel: 'Ukryj panel profilu',
		more: 'Więcej',
		imagesCount: 'Zdjęcia i wideo ({count})',
		imagesLabel: 'Obrazy',
		noImagesYet: 'W tej rozmowie nie wygenerowano jeszcze żadnych obrazów.',
		imagePlaceholder: 'Kolejny moment wpadnie tutaj',
		archiveConversation: 'Archiwizuj rozmowę z {name}',
		deleteConversationTitle: 'Usunąć rozmowę?',
		deleteConversationWarning: 'Tej operacji nie można cofnąć.',
		deleteConversationDeleting: 'Usuwanie...',
		deleteConversationDeleted: 'Usunięto',
		deleteConversation: 'Usuń rozmowę',
		no: 'Nie',
		yes: 'Tak',
		newChat: 'Nowy czat',
		search: 'Szukaj',
		searchPlaceholder: 'Szukaj rozmów...',
		loadingConversations: 'Ładowanie rozmów',
		noConversationsYet: 'Brak rozmów.',
		profileInfoAria: 'Informacje o profilu {name}',
		thinking: 'Myślę',
		typing: 'Pisze',
		processingMessage: 'Przetwarzanie wiadomości...',
		cancelRecording: 'Anuluj',
		noDescription: 'Brak szczegółowego opisu tego profilu.',
		newChatModalTitle: 'Wybierz swojego partnera!',
		newChatModalLoading: 'Ładowanie partnerów',
		newChatModalNoPersons: 'Brak dostępnych partnerów.',
	},

	audioError: {
		title: 'Problem z mikrofonem',
		subtitle:
			'Nie udało się uzyskać dostępu do mikrofonu. Sprawdź podłączenie urządzenia i uprawnienia przeglądarki.',
		deniedSubtitle:
			'Dostęp do mikrofonu został zablokowany. Zezwól na mikrofon w ustawieniach przeglądarki dla tej strony.',
		notFoundSubtitle:
			'Nie wykryto mikrofonu. Podłącz urządzenie audio lub sprawdź ustawienia systemowe.',
		inUseSubtitle:
			'Mikrofon jest używany przez inną aplikację. Zamknij ją i spróbuj ponownie.',
		unsupportedSubtitle:
			'Twoja przeglądarka nie obsługuje nagrywania głosu w tej aplikacji.',
		timeoutSubtitle:
			'Przekroczono czas oczekiwania na mikrofon. Sprawdź uprawnienia i spróbuj ponownie.',
		unknownSubtitle:
			'Wystąpił nieoczekiwany problem z mikrofonem. Sprawdź podłączenie urządzenia i uprawnienia.',
		mimeTypeUnsupportedSubtitle:
			'Twoja przeglądarka nie obsługuje nagrywania dźwięku. Spróbuj użyć Chrome, Safari lub Firefox.',
		checkPerms: 'Jak zezwolić na mikrofon:',
		guides: {
			chrome: 'Google Chrome',
			safari: 'Safari',
			mac: 'macOS',
			iphone: 'iPhone / iPad',
		},
		or: 'albo',
		mobileCta: 'Możesz też korzystać z aplikacji mobilnej:',
		android: 'Android',
		ios: 'iOS',
		retry: 'Odśwież stronę',
		tipRefresh:
			'Po zmianie uprawnień odśwież stronę i spróbuj rozpocząć rozmowę ponownie.',
	},
};
